import { NgModule } from '@angular/core';
import { NgxMaskModule } from 'ngx-mask';

import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core/core.module';
import { NotificationsComponent } from './notifications.component';
import { MessageItemComponent } from './message-item/message-item.component';
import { NzDatePickerModule } from 'ng-zorro-antd';


@NgModule({
  declarations: [
    NotificationsComponent,
    MessageItemComponent
  ],
  imports: [
    SharedModule,
    CoreModule,
    NgxMaskModule.forRoot({}),
    NzDatePickerModule
  ],
  exports: [
    NotificationsComponent,
    MessageItemComponent
  ],
  providers: []
})
export class NotificationsModule {

 }
